/* @flow */
import produce from 'immer';
import { message } from 'antd';
import { defineServerErrors } from '@/utils/redux';
import { actionTypes } from './actions';

const {
  SEND_INVITE,
  SEND_INVITE_SUCCESS,
  SEND_INVITE_FAILED,

  FETCH_INVITES,
  FETCH_INVITES_SUCCESS,
  FETCH_INVITES_FAILED,

  FETCH_TOKEN_DATA,
  FETCH_TOKEN_DATA_SUCCESS,
  FETCH_TOKEN_DATA_FAILED,

  TABLE_CHANGE,
} = actionTypes;

type State = {
  isInviteLoading: boolean,
  isFetchingInvites: boolean,
  isFetchingToken: boolean,
  tableOptions: TableT,
  data: InviteT[],
  invite: ?InviteT,
  errors: Array<string>,
  fetchTokenErrors: Array<string>,
  tokenData: ?Object,
};

const initialState = {
  isInviteLoading: false,
  isFetchingInvites: false,
  isFetchingToken: false,
  tableOptions: {
    page: 1,
    limit: 10,
    count: 0,
  },
  data: [],
  invite: null,
  errors: [],
  fetchTokenErrors: [],
  tokenData: {
    organization: {
      name: '',
    },
    email: '',
  },
};

export default (state: State = initialState, action: ActionT = {}): State =>
  produce(state, (draft) => {
    // eslint-disable-next-line default-case
    switch (action.type) {
      case SEND_INVITE:
        draft.isInviteLoading = true;
        return;
      case SEND_INVITE_SUCCESS:
        draft.invite = action.payload;
        draft.isInviteLoading = false;
        draft.errors = initialState.errors;
        message.success('Invite sent successfully.');
        return;
      case SEND_INVITE_FAILED:
        draft.isInviteLoading = false;
        draft.errors = defineServerErrors(action.payload, 'Some error has occurred. Please try again later.');
        draft.errors.forEach((error) => message.error(error, 10));
        return;
      case FETCH_INVITES:
        draft.isFetchingInvites = true;
        return;
      case FETCH_INVITES_SUCCESS: {
        const { results, page, limit, count } = action.payload;
        draft.isFetchingInvites = false;
        draft.data = results;
        draft.errors = initialState.errors;
        draft.tableOptions = {
          page,
          limit,
          count,
        };
        return;
      }
      case FETCH_INVITES_FAILED:
        draft.isFetchingInvites = false;
        draft.errors = defineServerErrors(action.payload, 'Some error has occurred. Please try again later.');
        draft.errors.forEach((error) => message.error(error, 10));
        return;
      case FETCH_TOKEN_DATA:
        draft.isFetchingToken = true;
        return;
      case FETCH_TOKEN_DATA_SUCCESS:
        draft.isFetchingToken = false;
        try {
          draft.tokenData = action.payload || initialState.tokenData;
        } catch (e) {
          draft.tokenData = initialState.tokenData;
        }
        return;
      case FETCH_TOKEN_DATA_FAILED:
        draft.fetchTokenErrors = defineServerErrors(action.payload, 'Some error has occurred. Please try again later.');
        draft.fetchTokenErrors.forEach((error) => message.error(error, 10));
        draft.isFetchingToken = false;
        return;
      case TABLE_CHANGE:
        draft.tableOptions = action.payload;
        return;
    }
  });
